import clsx from 'clsx';
import React, { lazy, Suspense } from 'react';
import { OutlineButton } from '../buttons/index.js';
import { cssEllipsis, cssWrapper, cssButton } from './index.css.js';

var GoTo = lazy(function () { return import('./GoTo.js'); });
var Pagination = function (_a) {
    var currentPage = _a.currentPage, totalPages = _a.totalPages, _b = _a.className, className = _b === void 0 ? '' : _b, showGoto = _a.showGoto, action = _a.action;
    var pageItem = function (i) {
        return (React.createElement("a", { key: i, className: clsx('c-pagination__page', {
                'c-pagination__page--active': currentPage === i
            }), onClick: function () {
                action(i);
            }, onKeyDown: function (e) {
                if (e.key === 'Enter') {
                    action(i);
                }
            }, tabIndex: 0 }, i));
    };
    var pageArr = [];
    for (var i = 1; i <= (totalPages < 5 ? totalPages : 5); i++) {
        var offset = 0;
        if (currentPage && totalPages > 5 && currentPage > 3) {
            offset = currentPage - 3;
            if (offset > totalPages - 5) {
                offset = totalPages - 5;
            }
        }
        if (i === 1) {
            pageArr.push(i);
        }
        else if (i > 1 && i < 5) {
            pageArr.push(i + offset);
        }
        else if (i === 5) {
            pageArr.push(totalPages);
        }
    }
    if (totalPages >= 5) {
        if (pageArr[4] > pageArr[3] + 1) {
            pageArr.splice(-1, 0, -1);
        }
        if (pageArr[1] > pageArr[0] + 1) {
            pageArr.splice(1, 0, -1);
        }
    }
    var pages = pageArr.map(function (p, idx) {
        if (p > 0) {
            return pageItem(p);
        }
        return (React.createElement("div", { className: cssEllipsis, key: "ellipsis-".concat(idx) }, "\u2026"));
    });
    var gotoPrevious = function () {
        if (currentPage) {
            var newPage = currentPage - 1;
            action(newPage > 1 ? newPage : 1);
        }
    };
    var gotoNext = function () {
        if (currentPage) {
            var newPage = currentPage + 1;
            action(newPage > totalPages ? totalPages : newPage);
        }
    };
    return (React.createElement("div", { className: clsx('c-pagination', className, cssWrapper) },
        !!totalPages && (React.createElement(OutlineButton, { className: cssButton, onClick: gotoPrevious, "aria-label": 'Previous page' },
            React.createElement("span", { className: clsx('icon-16-chevron-left-mono', 'c-pagination__button', {
                    'c-pagination__button--inactive': currentPage ? currentPage === 1 : true
                }) }))),
        pages,
        !!totalPages && (React.createElement(OutlineButton, { className: cssButton, onClick: gotoNext, "aria-label": 'Next page' },
            React.createElement("span", { className: clsx('icon-16-chevron-right-mono', 'c-pagination__button', {
                    'c-pagination__button--inactive': currentPage ? currentPage >= totalPages : true
                }) }))),
        showGoto && (React.createElement(Suspense, { fallback: '' },
            React.createElement(GoTo, { action: action, totalPages: totalPages, currentPage: currentPage })))));
};

export { Pagination };
//# sourceMappingURL=index.js.map
